(function() {
  'use strict';
  class AbideCustomerStoriesSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.abide-slider-list');
      this.sliderControls = this.querySelector('.abide-slider-controls');
      this.dotsContainer = this.querySelector('.abide-slider-dots');
      this.prevButton = this.querySelector('.prev-button');
      this.nextButton = this.querySelector('.next-button');
      this.isLoopEnabled = this.hasAttribute('loop-enabled');
      if (!this.slider || !this.sliderControls) return;

      this.slides = [...this.slider.children];
      this.totalSlides = this.slides.length;

      this.init();
    }

    init() {
      this.buildDots();
      this.setupObservers();
      this.setupEventListeners();
      if (this.isLoopEnabled && this.totalSlides > 1) {
        this.addClones();
        this.slider.scrollLeft = this.slider.offsetWidth;
      }
    }

    addClones() {
      const firstSlideClone = this.slides[0].cloneNode(true);
      const lastSlideClone = this.slides[this.totalSlides - 1].cloneNode(true);
      this.slider.prepend(lastSlideClone);
      this.slider.appendChild(firstSlideClone);

      this.clones = [lastSlideClone, firstSlideClone];
      this.totalClonedSlides = this.totalSlides + 2;
    }

    buildDots() {
      this.dotsContainer.innerHTML = '';
      this.slides.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'abide-slider-dot';
        dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
        dot.setAttribute('role', 'tab');
        dot.addEventListener('click', () => this.goToSlide(idx));
        this.dotsContainer.appendChild(dot);
      });
      this.dots = this.dotsContainer.querySelectorAll('.abide-slider-dot');
    }

    setupObservers() {
      const observerOptions = {
        root: this.slider,
        threshold: 0.5
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = this.slides.indexOf(entry.target);
            this.updateActiveDot(index);
          }
        });
      }, observerOptions);
      this.slides.forEach(slide => observer.observe(slide));
    }

    setupEventListeners() {
      this.prevButton.addEventListener('click', () => this.scrollByOne(-1));
      this.nextButton.addEventListener('click', () => this.scrollByOne(1));

      this.slider.addEventListener('scroll', () => {
        if (!this.isLoopEnabled || this.totalSlides <= 1) return;

        const currentScroll = this.slider.scrollLeft;
        const slideWidth = this.slides[0].offsetWidth;
        const lastSlideStart = slideWidth * this.totalSlides;
        const firstSlideStart = slideWidth;

        if (currentScroll >= lastSlideStart + slideWidth) {
          this.slider.style.scrollSnapType = 'none';
          this.slider.scrollLeft = firstSlideStart;
          setTimeout(() => this.slider.style.scrollSnapType = 'x mandatory', 50);
        }

        if (currentScroll <= 0) {
          this.slider.style.scrollSnapType = 'none';
          this.slider.scrollLeft = lastSlideStart;
          setTimeout(() => this.slider.style.scrollSnapType = 'x mandatory', 50);
        }
      });
      document.addEventListener('shopify:section:load', (e) => {
        if (e.target.contains(this)) {
          this.reinitialize();
        }
      });
    }

    goToSlide(index) {
      if (this.isLoopEnabled) {
        this.slider.scrollTo({
          left: this.slider.offsetWidth * (index + 1),
          behavior: 'smooth'
        });
      } else {
        const target = this.slides[index];
        if (target) this.slider.scrollTo({
          left: target.offsetLeft,
          behavior: 'smooth'
        });
      }
    }

    scrollByOne(direction) {
      const slideWidth = this.slides[0].offsetWidth;
      this.slider.scrollBy({
        left: direction * slideWidth,
        behavior: 'smooth'
      });
    }

    updateActiveDot(index) {
      this.dots.forEach(dot => dot.classList.remove('active'));
      if (this.dots[index]) {
        this.dots[index].classList.add('active');
      }
    }

    reinitialize() {
      this.slider.innerHTML = '';
      this.dotsContainer.innerHTML = '';

      this.slides.forEach(slide => this.slider.appendChild(slide.cloneNode(true)));
      this.slides = [...this.slider.children];
      this.totalSlides = this.slides.length;

      this.init();
    }
  }

  customElements.define('abide-slider-component', AbideCustomerStoriesSlider);
})();